import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/tailwind';

interface AssignedTeamMembersCountProps {
  inNavbar: boolean;
}

export const AssignedTeamMembersCount: React.FC<
  AssignedTeamMembersCountProps
> = ({ inNavbar }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn('text-grayscale-gray7 font-medium', !inNavbar && 'mb-2.5')}
    >
      {inNavbar ? t('Generic.chooseTeamMembers') : t('TrainingPlans.assigned')}
    </div>
  );
};
